const Chartjs = require("chart.js");
const ChartDataLabels = require("chartjs-plugin-datalabels");

Chartjs.defaults.global.defaultFontFamily = "Rubik";
Chartjs.defaults.global.defaultFontColor = "#646270";

Chartjs.defaults.global.elements.line.tension = 0;
Chartjs.defaults.global.elements.line.fill = false;
Chartjs.defaults.line.pointHoverRadius = 4;

Chartjs.defaults.horizontalBar.scales.yAxes[0].maxBarThickness = 50;
Chartjs.defaults.horizontalBar.layout = { padding: { right: 40 } };
Chartjs.defaults.horizontalBar.tooltips.mode = "y";

Chartjs.defaults.pie.legend.position = "right";
Chartjs.defaults.pie.tooltips.position = "nearest";
Chartjs.defaults.pie.tooltips.mode = "nearest";
Chartjs.defaults.pie.tooltips.intersect = true;


Chartjs.plugins.unregister(ChartDataLabels);
Chartjs.helpers.merge(Chartjs.defaults.global.plugins.datalabels, {
  font: {
    weight: 500,
    size: 11,
    family: Chartjs.defaults.global.defaultFontFamily,
    color: Chartjs.defaults.global.defaultFontColor
  }
});

Chartjs.pluginService.register({
  beforeUpdate(chart) {
    const defaultColors = {
      A: [
        "#aa4499",
        "#462987",
        "#3f59a9",
        "#4686c2",
        "#58a4ac",
        "#73b580",
        "#95bd5e",
        "#b9bd4a",
        "#d6b13e",
        "#e59235",
        "#e55e2b",
        "#d92120"
      ],
      B: [
        "#462987",
        "#3f59a9",
        "#4686c2",
        "#73b580",
        "#aa4499",
        "#58a4ac",
        "#e55e2b",
        "#d92120",
        "#d6b13e",
        "#e59235",
        "#b9bd4a",
        "#95bd5e"
      ]
    };

    const pickColor = function(index) {
      return defaultColors["A"][index % defaultColors.length];
    }

    switch (chart.config.type) {
      case "line", "horizontalBar":
        chart.data.datasets.forEach((dataset, index) => {
          if (!dataset.borderColor)
            dataset.borderColor = pickColor(index);

          if (!dataset.backgroundColor)
            dataset.backgroundColor = defaultColors[chart.config.colorSet || "A"];
        });
      break;
      case "pie":
        chart.data.datasets.forEach((dataset) => {
          if (!dataset.backgroundColor || dataset.backgroundColor.length == 0)
            dataset.backgroundColor = defaultColors[chart.config.colorSet || "A"];
        });
      break;
    }

  }
});

Chartjs.plugins.register({
    id: "minimum-arc-size",

    afterDatasetUpdate: function(chart, { index, meta }, _options) {
      if (meta.type !== "pie") // doughnut?
        return true;

      let dataset = chart.config.data.datasets[index];

      let computedTotal = meta.total;
      let minRatio = 0.01; // This could be made configurable.
      let minValue = computedTotal === 0 ? minRatio : minRatio * computedTotal;

      let actualTotal = 0;

      meta.data.forEach((arc, i) => {
        let value = 0;

        if (!arc.hidden) {
          value = Math.max(dataset.data[i], minValue);
        }

        arc._model.value = value;
        actualTotal += value;
      });

      if (actualTotal > 0) {
        meta.data.forEach((arc, i) => {
          if (i > 0) {
            arc._model.startAngle = meta.data[i - 1]._model.endAngle;
          }

          arc._model.circumference = 2 * Math.PI * (arc._model.value / actualTotal);
          arc._model.endAngle = arc._model.startAngle + arc._model.circumference;
        });
      }

      return true;
    }
});

Chartjs.scaleService.updateScaleDefaults("linear", {
  ticks: {
    beginAtZero: true,
    maxTicksLimit: 4,
    precision: 0
  },
  gridLines: {
    drawBorder: false
  }
});

Chartjs.scaleService.updateScaleDefaults("time", {
  gridLines: {
    display: false
  },
  time: {
    displayFormats: {
      month: "MMM YY"
    }
  }
});

Chartjs.scaleService.updateScaleDefaults("category", {
  ticks: {
    padding: 10
  }
});

Chartjs.defaults.global.tooltips.titleFontSize = 14;
Chartjs.defaults.global.tooltips.titleMarginBottom = 10;
Chartjs.defaults.global.tooltips.xPadding = 10;
Chartjs.defaults.global.tooltips.yPadding = 10;
Chartjs.defaults.global.tooltips.cornerRadius = 3;
Chartjs.defaults.global.tooltips.backgroundColor = "#212040";
Chartjs.defaults.global.tooltips.displayColors = false;
Chartjs.defaults.global.tooltips.mode = "index";
Chartjs.defaults.global.tooltips.intersect = false;


Chartjs.defaults.global.legend.labels.fontSize = 11;
Chartjs.defaults.global.legend.labels.boxWidth = 11;
Chartjs.defaults.global.legend.labels.fontStyle = "500";
Chartjs.defaults.global.legend.onHover = function(event) {
  event.target.style.cursor = "pointer";
}



// WEBPACK FOOTER //
// ./app/util/config/chartjs-config.js